import React from 'react'
import Form from '../components/registration/form'

const Registration = () => {
  return (
    <div>
        <Form/>
    </div>
  )
}

export default Registration